export class AuthenticationModel {
  constructor(public username: string, public password: string) {}
}
